import { useEffect } from "react"

export const closePacTabs = () => {
    window.__PAC_TRUSTED_LOGIN_TABS?.forEach((tab) => tab.postMessage("close", "*"))
    window.__PAC_TRUSTED_LOGIN_TABS = []
}

export const useCloseListener = (callback: () => void) => {
    useEffect(() => {
        window.addEventListener("beforeunload", callback)
        return () => window.removeEventListener("beforeunload", callback)
    }, [callback])
}
